import { is } from "app/pages/sales-intelligence/utils/type-guards";

import { signalTypeMap } from "../types/signal";
import type { SignalsGroupedByTypeKey, SignalsDTO } from "../types/signal-collection";

import { toSignalTypeKey } from "./signal-key";

export const createEmptySignalsBySignalTypeKey = (): Readonly<SignalsGroupedByTypeKey> =>
    Object.values(signalTypeMap).reduce<SignalsGroupedByTypeKey>(
        (acc, signalType) => ({ ...acc, [toSignalTypeKey(signalType)]: [] }),
        {} as SignalsGroupedByTypeKey,
    );

/** Fans a signalsFilters DTO out into per-type signal-type-key values. */
export const splitSignalsDTO = (dto: SignalsDTO | undefined): Readonly<SignalsGroupedByTypeKey> => {
    if (!dto) {
        return createEmptySignalsBySignalTypeKey();
    }

    return Object.values(signalTypeMap).reduce<SignalsGroupedByTypeKey>((acc, signalType) => {
        const signalsOfType = dto[signalType];

        if (is.undefined(signalsOfType)) {
            return acc;
        }

        acc[toSignalTypeKey(signalType)] = signalsOfType;

        return acc;
    }, createEmptySignalsBySignalTypeKey());
};

/** Merges per-type signal-type-key values back into a single signalsFilters DTO (every SignalType slot present). */
export const assembleSignalsDTO = (values: Partial<SignalsGroupedByTypeKey>): SignalsDTO =>
    Object.values(signalTypeMap).reduce<SignalsDTO>(
        (acc, signalType) => ({
            ...acc,
            [signalType]: values[toSignalTypeKey(signalType)] ?? [],
        }),
        {} as SignalsDTO,
    );
